import * as React from 'react';

import GrowthDiscoveryExperiments from 'bundles/epic/clients/GrowthDiscovery';

export default ({ score }: $TSFixMe) => {
  if (score && GrowthDiscoveryExperiments.get('showMultiModuleRerankingDebugScores')) {
    return (
      <span style={{ position: 'absolute', background: 'white', border: '2px solid black', zIndex: 9999 }}>
        (su only) score: {score}
      </span>
    );
  }
  return null;
};
